import { useEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { AddToCartFormDraft } from "~/features/addToCart/hooks/useAddToCartForm";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useTranslation } from "react-i18next";
import { Snackbar, SnackbarCloseButton } from "~/common/mui/Snackbar/Snackbar";

export const QuantityChangedSnackbar = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddToCartFormDraft>();
  const quantity = useWatch({ control, name: "quantity" });
  const previousQty = useRef(quantity);

  const { val, setTrue, setFalse } = useBooleanState(false);

  useEffect(() => {
    if (quantity !== previousQty.current) {
      setTrue();
    }
    previousQty.current = quantity;
  }, [quantity]);

  return (
    <Snackbar
      open={val}
      onClose={setFalse}
      message={t("housing.snackbar.qtyChanged")}
      action={<SnackbarCloseButton onClick={setFalse} />}
    />
  );
};
